import { BirdviewActivityRow } from '../BirdviewActivityRow'
import { BirdviewServiceRequestRow } from '../BirdviewServiceRequestRow'
import { BirdviewAttentionEntity } from '../DashboardBirdview.constants.attention'
import { checkIsBirdviewActivityDone } from '../DashboardBirdview.utils.rows'

// Request and activity ids can collide in one group, so the key has the entity.
function getBirdviewAttentionRowItem({
  activityDoneById,
  extra,
  item,
  pendingIds,
  requestActions,
  onActivityToggle,
  onOpenItem,
}) {
  const key = `${item.entity}-${item.id}`

  switch (item.entity) {
    case BirdviewAttentionEntity.Activity:
      return (
        <BirdviewActivityRow
          isDone={checkIsBirdviewActivityDone(item, activityDoneById)}
          isPending={pendingIds.includes(item.id)}
          item={item}
          key={key}
          onOpen={onOpenItem}
          onStatusToggle={onActivityToggle}
        />
      )
    case BirdviewAttentionEntity.Request:
      return (
        <BirdviewServiceRequestRow
          extra={extra}
          item={item}
          key={key}
          requestActions={requestActions}
          onOpen={onOpenItem}
        />
      )
    default:
      return null
  }
}

export function getBirdviewAttentionRowItems({ items, ...rowProps }) {
  return items.map(item => getBirdviewAttentionRowItem({ ...rowProps, item }))
}
